import 'chartist/dist/index.css'
import VueChartist from 'vue-chartist'

export default function installChartistPlugin(app) {
  app.use(VueChartist)
}